import { api } from './api';
export interface TeamSignature {
  template: string;
  enabled: boolean;
  revision: number;
  preview: string;
  sender: {
    name: string;
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
  };
}
export const TeamSignatureAPI = {
  get: async (): Promise<TeamSignature> =>
    (await api.get<TeamSignature>('/api/admin/team-signature/')).data,
  save: async (
    data: Pick<TeamSignature, 'template' | 'enabled' | 'revision'>,
  ): Promise<TeamSignature> =>
    (await api.put<TeamSignature>('/api/admin/team-signature/', data)).data,
};
